import { CommonModule, NgClass } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, Output, inject } from '@angular/core';
import { ControlContainer, FormsModule, NgForm } from '@angular/forms';
import { GtmService } from '@df/module-gtm/gtm.service';
import { OffClickModule } from '@df/module-off-click/off-click.module';
import { OrderByPipe } from '@df/ui/common/order-by.pipe';
import { ValidatePatternDirective } from '@df/ui/form/validate-pattern.directive';
import { TranslationModule } from '@df/ui/translation/translation.module';
import { LocalGtmService } from '../../module/gtm/gtm.service.decorator';
import { MuiInputDirective } from '../../module/legacy/forms/mui-input.directive';
import { AbstractAccountAddressFieldsetComponent } from './abstract-address-fieldset.component';
import { CheckboxComponent } from './checkbox';
import { InputWrapBodyDirective } from './input-wrap-body.directive';
import { InputWrapComponent } from './input-wrap.component';
@Component({
    selector: 'address-fieldset',
    templateUrl: 'address-fieldset.html',
    viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
    standalone: true,
    imports: [
        FormsModule,
        TranslationModule,
        MuiInputDirective,
        InputWrapComponent,
        NgClass,
        OrderByPipe,
        OffClickModule,
        CheckboxComponent,
        InputWrapBodyDirective,
        ValidatePatternDirective,
        CommonModule
    ]
})
export class AddressFieldsetComponent extends AbstractAccountAddressFieldsetComponent implements OnChanges {
    @Output()
    saveAddress = new EventEmitter();

    readonly gtmService = inject(GtmService);

    @Input()
    stepName?: string;

    search(): void {
        this.searcher?.search();
        this.searcher?.status.promise?.then(r => {
            !r?.predict?.lenght && this.sendGA4Error({ error: 'address lookup failure' });
        });
    }

    private sendGA4Error = (e: { error: string }): void => {
        (this.gtmService as LocalGtmService).sendFormError(
            e?.error,
            'checkout ' + (this.type === 'billing' ? 'payment' : 'delivery'),
            this.type === 'billing' ? 3 : 2
        );
    };

    onInputBlur(): void {
        this.saveAddress.emit();
    }
}
